// reducers.js
import { combineReducers } from 'redux';
import recordsReducer from '../reducers/records'; 
import recordReducer from '../reducers/popupdata.reducer';
import filterdata from '../reducers/filterdata/index'

export default combineReducers({
  // datarecords: popupdatareducer,
  popupdata: recordReducer,
  record: recordsReducer,
  filterdata:filterdata

});

